import { defaultValues as addressDefaultValues } from "@/components/form-fields/AddressForm/utils/defaultValues";
import { StepElecContractFormData, IStepInstallationFormData, IStepPersonFormData } from "../types/stepsFormData";
import { FetchCUPSAvailabilityData } from "../types/cups";

export const installationStep: IStepInstallationFormData = {
  cups: '',
  cupsSIPSData: {}, //TODO: why doesn't this complain???
  address: addressDefaultValues,
  // TODO: Add Settings.contractation?.defaultCnaeCheck
  residenceType: "habitual",
  cnae: { 
    id: 986, 
    name: "9820", 
    descripcio: "9820: Actividades de los hogares como productores de servicios para uso propio" 
  },
  invoice: [],
  comerOrigin: '',
  activeContract: null,
  acceptMorosityVerification: false,
  leadsConsent: false,
}

export const personStep: IStepPersonFormData = {
  vat: '',
  company: false,
  name: '',
  surName1: '',
  surName2: '',
  cif: '',
  changeOwner: null,
  vatRepresentante: '',
  nameRepresentante: '',
  surName1Representante: '',
  surName2Representante: '',
  sameInvoiceAddress: true,
  ownerAddress: {
    dp: '',
    ine: '',
    nv: '',
    pnp: '',
    poblacio: '',
    state: '',
    tv: '',
    aclarador: '',
    bq: '',
    es: '',
    pt: '',
    pu: '',
    ref_catastral: '',
  },
  commsLanguage: '',
  email: '',
  mobile: '',
  nifFaceup: [],
  nifEmpresa: [],
  vatTokenized: false,
  activeContract: false,
}

// TODO: Fix these types
export const contractStep: StepElecContractFormData = {
  power: null,
  power2: null,
  power3: null,
  power4: null,
  power5: null,
  power6: null,
  accessTariff: null,
  selfcons: false,
  selfconsCode: '00',
  selfconsAttachments: [],
  selectedProduct: undefined,
  promotionalCode: [],
}

export default {
  
  submitting: false,
  leadId: null,
  gasLeadId: null,
  leadsConsent: false,
  leadErrors: {
    badScore: false,
    dniInvalid: false,
    genericError: false
  },

  latestStep: 0,
  completedSteps: {},
  currentStep: {
    index: 0,
    name : "installation"
  },

  config: {
    name: '',
    surName1: '',
    surName2: '',
    mobile: '',
    vat: '',
    email: '',
    isFetching: true
  },
  gasConfig: {
    name: '',
    surName1: '',
    surName2: '',
    mobile: '',
    vat: '',
    email: '',
    isFetching: true
  },

  steps: {
    installation: installationStep,
    person: personStep,
    contract: contractStep,
    gasContract: {
      comerOrigin: '',
      includeGas: false,
      cups: '',
      cupsSIPSData: {
        cupsAvailable: true
      },
      changeOwner: '',
      activeContract: null,
      accessTariff: null,
      selectedProduct: null,
      selectedProductName: '',
      invoice: []
    },
    payment: {
      iban: '',
      isOwner: false,
    },
    confirmation: {
      acceptOVConditions: false,
      acceptGdpr: false,
      acceptPublicity: false,
      isConfirming: false,
      confirmStatus: 'pending', // 'pending' | 'OK'
      confirmResponse: null,
    }
  },
  
  availableProducts: [],
  selectedProduct: null,
  selectedProductName: null,
};